<template>
    <tr>
        <td>
            <button class="button is-primary" @click="saveItem" :disabled="isLocked">
                <i class="fas fa-save"></i>
            </button>
        </td>
        <td>
            <input class="input" v-model="name" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" v-model="remarks" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" v-model="amount" :disabled="isLocked"/>
        </td>
        <td></td>
    </tr>
</template>

<script>
    export default {
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            name: {
                get() {
                   return this.$store.getters.getProformaInvoiceNewCostItem.name
                },
                set(value) {
                   this.$store.dispatch('changeProformaInvoiceNewCostItemFieldValue', { field: 'name', value: value})
                }
            },
            remarks: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewCostItem.remarks
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewCostItemFieldValue', { field: 'remarks', value: value})
                }
            },
            amount: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewCostItem.amount
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewCostItemFieldValue', { field: 'amount', value: value})
                }
            }
        },
        methods: {
            saveItem() {
                this.$store.dispatch('saveProformaInvoiceCostItem')
                this.$store.dispatch('changeProformaInvoiceTotalCostAmount')
                this.$store.dispatch('calculateProformaInvoice')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceCostsTableCreateRow.vue